import { AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions, { requestWithProgress } from "../../AxiosActions";

export const downloadFileById = (id: number, spinner = true, config = {}): Promise<AxiosResponse> => {
    return requestWithProgress(getAxiosInstances().V2, "get", `/file/${id}/download`, {}, { ...config, responseType: "blob" }, spinner);
};

export const downloadFileByIdNoProgress = (id: number, spinner = true, config = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/file/${id}/download`, { ...config, responseType: "blob" }, spinner);
};

export const getAllFilesByBoi = (instanceId: number, typeKey: string, relationKeys: string[], spinner = true, config = {}): Promise<AxiosResponse> => {
    const relations = relationKeys.map((key) => `relKeys=${key}`).join("&");
    return AxiosActions.get(getAxiosInstances().V2, `/file/all/${typeKey}/${instanceId}?${relations}`, { ...config }, spinner, true);
};
export const createFileVersion = (fileId: number, isCurrent: boolean, file: any, versionName?: string): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.append("fileNewVersion", file);
    const versionNameParam = versionName ? `&versionName=${versionName}` : "";
    return AxiosActions.post(getAxiosInstances().V2, `/file/${fileId}/version?current=${isCurrent}${versionNameParam}`, formData, {}, true);
};
export const queryByRelationship = (
    typeKey: string,
    instanceId: number,
    relKey: string,
    targetTypeKey: string,
    targetInstanceFilteringDTO: object,
    spinner = false,
    config: { includeRelAttributes?: boolean; [key: string]: any } = {},
) => {
    const { includeRelAttributes = false, ...axiosConfig } = config;
    return AxiosActions.post(
        getAxiosInstances().V2,
        `/query/${typeKey}/${instanceId}?relKey=${relKey}&targetTypeKey=${targetTypeKey}&includeRelAttributes=${includeRelAttributes}`,
        targetInstanceFilteringDTO,
        axiosConfig,
        spinner,
    );
};
export const queryInstancesByTypeKey = (typeKey: string, spinner = false, config = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/query/${typeKey}`, { params: { limit: 100 }, ...config }, spinner);
};

export const deleteFile = (fileId: number | string): Promise<AxiosResponse> => {
    return AxiosActions.delete(getAxiosInstances().V2, `/file/${fileId}?hardDelete=true`, {}, true);
};

// Shape of access-control/role/all entries (AcRoleDTO on the BE).
export interface IAcRole {
    id: number;
    roleName: string;
}

// excludeSystemRoles hides the reserved roles (Everything, Proctor, Doctor, graphiql) — NG-8529.
export const getAllRoles = (config, excludeSystemRoles = false): Promise<AxiosResponse> => {
    return AxiosActions.get(
        getAxiosInstances().V2,
        `access-control/role/all?limit=9999${excludeSystemRoles ? "&excludeSystemRoles=true" : ""}`,
        { ...config },
        false,
    );
};

export const uploadFileToRelation = (
    file: File,
    metadata: {
        typeKey: string;
        relKey: string;
        targetInstanceId: string | number;
        isPublic: boolean;
    },
    showSpinner = true,
    config: any = {},
): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    return AxiosActions.post(
        getAxiosInstances().V2,
        `/health/type/${metadata.typeKey}/${metadata.targetInstanceId}/relation/${metadata.relKey}/file/upload`, // ?fileName=${file.name}&isPublic=${metadata.isPublic}
        formData,
        {
            params: {
                fileName: file.name,
                isPublic: metadata.isPublic,
            },
            ...config,
        },
        showSpinner,
        true,
    );
};
